import PropTypes from "prop-types";
import { EXPERIENCE } from "@data/experience";
import useTranslations from "@hooks/useTranslations";
import { localize } from "@utils/i18n";
import { useLanguage } from "@contexts/LanguageContext";
import { ICONS } from "@utils/icons";

/**
 * Bloc d'expériences filtré par nature, pour reprendre les deux sections
 * distinctes du CV : « Expériences en développement » et « Formations
 * dispensées & enseignement ».
 */
const Experience = ({ type }) => {
  const t = useTranslations();
  const { lang } = useLanguage();

  const isDev = type === "dev";
  const items = EXPERIENCE.filter((item) => item.type === type);

  return (
    <div className="col-12" data-section={`experience-${type}`}>
      <div className="bostami-section-title-wrap mb-20 mt-40">
        <h4 className="section-title">
          <i className={isDev ? ICONS.experience : ICONS.education} />
          {isDev ? t.cv.devExperience : t.cv.teachingExperience}
        </h4>
      </div>

      <div className="bostami-card-wrap">
        {items.map((element) => {
          const item = localize(element, lang);
          return (
            <div
              className={`bostami-card-item mb-20 ${isDev ? "bg-catkrill" : "bg-prink"}`}
              key={`${element.poste}-${element.debut}-${element.fin}`}
            >
              <span className="card-subtitle">
                {item.debut} - {item.fin}
              </span>
              <h6 className="card-title">{item.poste}</h6>
              <p className="card-text">{item.etablissement}</p>
              {item.clients && (
                <p className="card-text mb-0">
                  <em>
                    {t.cv.clients} : {item.clients}
                  </em>
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

Experience.propTypes = {
  type: PropTypes.oneOf(["dev", "formation"]).isRequired,
};

export default Experience;
